import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
      if (control.value && !emailRegex.test(control.value)) {
        return { 'emailInvalido': true };
      }
  
      return null;
    };
  }

export const rutValidator = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    if(value == ''){
        return null;
      }

    if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( value )) {
      return { rut: true };
    }

    const tmp 	= value.split('-');
    let digv	= tmp[1];
    const rut 	= tmp[0];
    if ( digv == 'K' ) {digv = 'k'; }

    let M = 0;
    let S = 1;
    for (; digv; digv = Math.floor(digv / 10)) {
      S = (S + digv % 10 * ( 9 - M ++ % 6 )) % 11;
    }
    const calculatedDv =  S ? S - 1 : 'k';
    return digv == calculatedDv ? { rut: true} : null ;
  
}